import type { TFunction } from "@/hooks/useTranslation"
import { HeaderCell } from "@/molecules/HeaderCell"

export const KodemScoreHeaderCell = (t: TFunction) =>
  HeaderCell({
    title: t("general.kodemScore.plain"),
    Content: t("general.kodemScore.tooltip")
  })
